import { gql } from "@apollo/client";

export const UPDATE_AJUSTE_LIQUIDACION = gql`
    mutation updateAjusteLiquidacion($input: UpdateAjusteLiquidacionInput!) {
        updateAjusteLiquidacion(input: $input) {
            idAjusteLiquidacion
            ajuste
            observacionAjuste
            idMotivoAjuste
        }
    }
`;